import React from 'react'
import { Row, Col, Form, InputGroup } from 'react-bootstrap'
import CurrencyInput from 'react-currency-input'

export default function OutrasInformacoesSection({
  localTrabalho,
  renda,
  outrasRendas,
  allDisabled,
  onChange,
  onChangeRenda,
  onChangeOutrasRendas,
}) {
  return (
    <>
      <Row className="mt-3 pt-2 mb-0">
        <Col>
          <h2 className="paciente-form-section-title mb-0">Outras informações</h2>
        </Col>
      </Row>
      <Row className="form-row align-items-start">
        <Col xs={12} sm={6} xl={4}>
          <Form.Group className="required">
            <Form.Label htmlFor="localTrabalho">Local de trabalho</Form.Label>
            <Form.Control
              type="text"
              name="localTrabalho"
              value={localTrabalho}
              onChange={onChange}
              required
              maxLength={100}
              disabled={allDisabled}
            />
          </Form.Group>
        </Col>
        <Col xs={12} sm={6} xl={4}>
          <Form.Group>
            <Form.Label htmlFor="renda">Renda</Form.Label>
            <InputGroup className="mb-0">
              <InputGroup.Prepend>
                <InputGroup.Text>R$</InputGroup.Text>
              </InputGroup.Prepend>
              <CurrencyInput
                className="form-control"
                name="renda"
                decimalSeparator=","
                thousandSeparator="."
                value={renda}
                onChange={onChangeRenda}
                disabled={allDisabled}
              />
            </InputGroup>
          </Form.Group>
        </Col>
        <Col xs={12} sm={6} xl={4}>
          <Form.Group>
            <Form.Label htmlFor="outrasRendas">Outras rendas</Form.Label>
            <InputGroup className="mb-0">
              <InputGroup.Prepend>
                <InputGroup.Text>R$</InputGroup.Text>
              </InputGroup.Prepend>
              <CurrencyInput
                className="form-control"
                name="outrasRendas"
                decimalSeparator=","
                thousandSeparator="."
                value={outrasRendas}
                onChange={onChangeOutrasRendas}
                disabled={allDisabled}
              />
            </InputGroup>
          </Form.Group>
        </Col>
      </Row>
    </>
  )
}
